import { render, staticRenderFns } from "./crmProduct.vue?vue&type=template&id=cc7a0e12&scoped=true"
import script from "./crmProduct.vue?vue&type=script&lang=js"
export * from "./crmProduct.vue?vue&type=script&lang=js"
import style0 from "./crmProduct.vue?vue&type=style&index=0&id=cc7a0e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7a0e12",
  null
  
)

export default component.exports